export const OTHER_REASON_ID = 'other';

export const LISTING_CRITERIA = Object.freeze([
  Object.freeze({
    key: 'completeness',
    title: 'Profile completeness',
    items: Object.freeze([
      Object.freeze({
        id: 'description_incomplete',
        label: 'Missing or incomplete company description',
      }),
      Object.freeze({
        id: 'logo_quality',
        label: 'Logo or cover image missing or too low quality',
      }),
      Object.freeze({
        id: 'contact_unverifiable',
        label: 'Contact details incomplete or unverifiable',
      }),
    ]),
  }),
  Object.freeze({
    key: 'accuracy',
    title: 'Content quality / Accuracy',
    items: Object.freeze([
      Object.freeze({
        id: 'website_unreachable',
        label: 'Company website is not live or not accessible',
      }),
      Object.freeze({
        id: 'expertise_mismatch',
        label:
          "Listed expertise, tags or industries don't match the company's actual offering",
      }),
      Object.freeze({
        id: 'placeholder_text',
        label: 'Description contains placeholder or template text',
      }),
    ]),
  }),
  Object.freeze({
    key: 'policy',
    title: 'Guidelines / Policy',
    items: Object.freeze([
      Object.freeze({
        id: 'branding_conflict',
        label:
          'Company name, logo, or branding conflicts with an existing listing',
      }),
      Object.freeze({
        id: 'inappropriate_content',
        label: 'Inappropriate, offensive or misleading content',
      }),
      Object.freeze({
        id: 'duplicate_listing',
        label: 'Listing appears to be a duplicate of an existing partner',
      }),
    ]),
  }),
  Object.freeze({
    key: 'trust',
    title: 'Trust / Eligibility',
    items: Object.freeze([
      Object.freeze({
        id: 'business_unverifiable',
        label:
          'Unable to verify the business is legitimate or currently operating',
      }),
      Object.freeze({
        id: 'irrelevant_services',
        label:
          'Company does not offer services relevant to the Swell partner directory',
      }),
    ]),
  }),
]);

const REASON_LABELS_BY_ID = Object.freeze(
  Object.fromEntries(
    LISTING_CRITERIA.flatMap((category) =>
      category.items.map((item) => [item.id, item.label]),
    ),
  ),
);

export function getReasonLabel(id) {
  return REASON_LABELS_BY_ID[id];
}

// The stored reason carries its own label so the record stays readable without
// this module, and so a historical rejection keeps the wording actually sent.
export function buildRejectionReasons(ids, note = '') {
  const trimmedNote = (note || '').trim();

  return (ids || []).reduce((reasons, id) => {
    if (id === OTHER_REASON_ID) {
      if (trimmedNote) {
        reasons.push({ id, label: trimmedNote });
      }

      return reasons;
    }

    const label = getReasonLabel(id);

    if (label) {
      reasons.push({ id, label });
    }

    return reasons;
  }, []);
}
